var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.errorText)?_c('v-row',[_c('v-icon',{attrs:{"large":"","color":"red darken-2"}},[_vm._v(" mdi-alert-outline ")]),_c('span',[_vm._v(" "+_vm._s(_vm.errorText)+" ")])],1):_c('LoadingCircle')],1)}
var staticRenderFns = []

export { render, staticRenderFns }